import eventBus from './events.js';

const $ = jQuery;

let attendees = [];

const CACHE_KEY = typeof FESTIVAL_ATTENDEE_CACHE_KEY === 'undefined' ? 'festival_attendee_cache' : FESTIVAL_ATTENDEE_CACHE_KEY;

function getCacheObjet(name) {
    return window.localStorage && window.localStorage.getItem(name)
        ? JSON.parse(window.localStorage.getItem(name)) : {};
}

const cache = getCacheObjet(CACHE_KEY);
const attendeeSelections = getCacheObjet(CACHE_KEY + '_attendees_selections');

/**
 * Add attendee from the billing information.
 * @param attendees
 */
function addPurchaser(attendees) {
    const info = {
        'FirstName': $('#billing_first_name').val(),
        'LastName': $('#billing_last_name').val(),
        'Email': $('#billing_email').val()
    }

    if (info.FirstName && info.LastName && info.Email) {
        addAttendee(info);
    }
}

/**
 * Add attendee to list.
 * @param {Object} attendees
 * @param {Object} info
 */
function addAttendee(info) {
    attendees.push(info);

    updateAttendeeCache();

    return attendees.length - 1;
}

function updateAttendee(index, info) {
    attendees[index] = {...attendees[index], ...info};

    updateAttendeeCache();

    $('.attendee-dropdown option:selected[value="' + index + '"]').each(function () {
        selectAttendeeFromDropdown.call(this.parentNode, false);
    });
}

export function getAttendee(index) {
    return attendees[index];
}

function updateAttendeeCache() {
    if (window.localStorage) {
        window.localStorage.setItem(CACHE_KEY + '_attendees', JSON.stringify(attendees));
        window.localStorage.setItem(CACHE_KEY + '_attendees_selections', JSON.stringify(attendeeSelections));
    }
}

function createDropdown(id_prefix) {
    const dropdown = $('<select class="attendee-dropdown -invalid"></select>');
    dropdown.attr('id', id_prefix + '_attendee_dropdown');

    const options = [];
    options.push($(`<option value="" selected>${FestivalI18n.select_attendee}</option>`));
    options.push($(`<option value="new">${FestivalI18n.add_new_attendee}</option>`));
    options.push(...buildAttendeeDropdownOptions(attendees));

    dropdown.append(...options);

    return dropdown;
}

/**
 * Replace the copy from purchaser button with a dropdown of attendees.
 * @param {Object} attendees
 */
function initializeDropdowns(attendees, complete = () => {
}) {
    $('.fooevents-attendee--updating').closest('.fooevents-tickets-group').remove();
    $('.fooevents-attendee').each(function () {
        if ($(this).find('.attendee-dropdown').length > 0) {
            return; // already initialized
        }
        const dropdown = createDropdown($(this).attr('id'));
        const wrapper = $('<div class="attendee-dropdown-wrapper"></div>');
        dropdown.appendTo(wrapper);

        const copyElement = $('.fooevents-copy-from-purchaser', this);
        if (copyElement.length > 0) {
            copyElement.parent().replaceWith(wrapper);
        } else {
            wrapper.insertBefore($('.attendee-class', this).first());
        }

        if (attendeeSelections[dropdown.attr('id')] && dropdown.val() === '') {
            dropdown.val(attendeeSelections[dropdown.attr('id')]).trigger('change');
            selectAttendeeFromDropdown.call(dropdown, false);
        }

        if ($('.save-attendee', this).length === 0) {
            $(`<div class="attendee-class text-right"><button class="frButton -small -secondary save-attendee" type="button">${FestivalI18n.save_attendee_button}</button></div>`).appendTo($(this));
        }

        $('.attendee-class', this).hide();
    }).promise().done(function () {
        complete();
        eventBus.trigger('attendee_dropdowns_initialized');
    });
}

export function getAttendeeName(index) {
    const att = attendees[index];
    let name = (att.FirstName || '') + (att.FirstName ? ' ' : '') + (att.LastName || '');
    if (name.length === 0) {
        name = Object.values(att).join(' | ');
    }

    return name;
}

function buildAttendeeDropdownOptions(attendees) {
    const options = [];
    for (let i in attendees) {
        options.push($('<option>').val(i).html(getAttendeeName(i)));
    }

    return options;
}

/**
 * Refresh dropdowns when attendees list changes and trigger callback once completed.
 * @param {Object} attendees
 * @param {Function} cb
 */
function refreshDropdowns(attendees, cb) {
    const $dropdowns = $('.attendee-dropdown');
    let length = $dropdowns.length;
    $dropdowns.each(function () {
        const value = this.value;
        const $dropdown = $(this);
        $dropdown.html('');
        const options = [];
        options.push(`<option value="" selected>${FestivalI18n.select_attendee}</option>`);
        options.push(buildAttendeeDropdownOptions(attendees));
        options.push(`<option value="new">${FestivalI18n.add_new_attendee}</option>`);
        $dropdown.append(...options);
        $dropdown.val(value);
        if (--length === 0 && typeof cb === 'function') {
            cb();
        }
    });
}

function prepareAttendeeKey(v) {
    return v.replace(/[^a-zA-Z]/g, '');
}

/**
 * Fills attendee form when the dropdown is changed.
 * @param {Boolean} updateSiblings - Whether to update other ticket details with the same attendee.
 */
export function selectAttendeeFromDropdown(updateSiblings = true) {
    const $parent = $(this).closest('.fooevents-attendee');
    const $dropdown = $('.attendee-dropdown', $parent);
    $dropdown.removeClass('-invalid -valid');

    const value = $dropdown.val();

    if (['new', '', null].indexOf(value) === -1) {
        const attendee = attendees[value];
        const inputs = $('input,select', $parent);
        for (let i = 0; i < inputs.length; i++) {
            const $input = $(inputs[i]);
            if ($input.attr('type') !== 'hidden') {
                const $label = $('label', $input.closest('.form-row'));
                if (attendee[prepareAttendeeKey($label.text())]) {
                    $input.val(attendee[prepareAttendeeKey($label.text())]).trigger('change');
                }
            }
        }

        if ($parent.find('.attendee-edit').length === 0) {
            $(`<a class="attendee-edit" href="javascript:void(0)">${FestivalI18n.edit_attendee}</a>`).insertAfter($dropdown.parent());
        }

        $('.attendee-class', $parent).hide();
        $dropdown.addClass('-valid');

        attendeeSelections[$dropdown.attr('id')] = value;
        updateAttendeeCache();

        const bundle = $parent.data('bundle');
        if (typeof bundle !== 'undefined' && updateSiblings) {
            const bundleAttendee = $parent.data('attendee');
            $(`#fooevents_order_notes_page_load .fooevents-attendee[data-bundle="${bundle}"][data-attendee="${bundleAttendee}"] .attendee-dropdown`).not(this).val(value).each(function () {
                selectAttendeeFromDropdown.call(this, false);
            });
        }

        validateAttendeeFields($parent);
    } else {
        $parent.find('.attendee-edit').hide();
        $(':input[type!="hidden"]:not(button)', $parent).val('');
        if (value === 'new') {
            $dropdown.val('new');
            $('.attendee-class', $parent).show();
        } else {
            $('.attendee-class', $parent).hide();
            $dropdown.addClass('-invalid');
        }
    }

}

function validateAttendeeFields($attendeeEl) {
    const fields = $attendeeEl.find('input,select').not('.attendee-dropdown').not('[type="hidden"]');
    fields.each(function () {
        attendeeFieldValidator.call(this, new Event('validate'));
    });

    const hasErrors = $attendeeEl.find('.woocommerce-validated').length < fields.length;

    if (hasErrors) {
        $('.attendee-edit', $attendeeEl).trigger('click');
        $('.attendee-dropdown', $attendeeEl).addClass('-invalid').removeClass('-valid');
    } else {
        $('.attendee-edit', $attendeeEl).show();
        $('.attendee-dropdown', $attendeeEl).removeClass('-invalid').addClass('-valid');
    }
}

/**
 * Saves changed attendee info and triggers a dropdown refresh.
 */
function saveAttendeeInfo() {
    const $parent = $(this).closest('.fooevents-attendee');
    const inputs = $('input,select', $parent).not('select.attendee-dropdown');

    const info = {};
    for (let i = 0; i < inputs.length; i++) {
        const $input = $(inputs[i]);
        if ($input.attr('type') !== 'hidden') {
            const $label = $('label', $input.closest('.form-row'));
            info[prepareAttendeeKey($label.text())] = $input.val();
        }
    }

    if (Object.values(info).join('') === '') {
        return; // Do nothing if fields are empty
    }

    let index = parseFloat($('.attendee-dropdown', $parent).val());
    if (Number.isNaN(index)) {
        index = addAttendee(info);
    } else {
        updateAttendee(index, info);
    }

    refreshDropdowns(attendees, function () {
        // Update any attendees with the same selection
        $('.attendee-dropdown').each(function () {
            if ($(this).val() === index) {
                selectAttendeeFromDropdown.call(this);
            }
        });

        $('.attendee-dropdown', $parent).val(index).trigger('change').addClass('-valid');
    });
}

function cacheAttendeeInputValue() {
    cache[$(this).attr('id')] = $(this).val();
    if (window.localStorage) {
        window.localStorage.setItem(CACHE_KEY, JSON.stringify(cache));
    }
}

function loadAttendeeInputsFromCache() {
    for (const i in cache) {
        const el = $('#' + i);
        el.val(cache[i]).trigger('input');
        if (el.hasClass('attendee-dropdown')) {
            selectAttendeeFromDropdown.call(el, true);
        }
    }
}

/**
 * Modified from checkout.js to support validating fields outside the checkout form selector.
 * @param e
 */
function attendeeFieldValidator(e) {
    var $this = $(this),
        $parent = $this.closest('.form-row'),
        validated = true,
        validate_required = $parent.is('.validate-required'),
        validate_email = $parent.is('.validate-email') || ($this.attr('name') || '').indexOf('email') > -1,
        validate_phone = $parent.is('.validate-phone') || ($this.attr('name') || '').indexOf('phone') > -1,
        pattern = '',
        event_type = e.type;

    if ('input' === event_type) {
        $parent.removeClass('woocommerce-invalid woocommerce-invalid-required-field woocommerce-invalid-email woocommerce-invalid-phone woocommerce-validated'); // eslint-disable-line max-len
    }

    if ('validate' === event_type || 'change' === event_type) {

        if (validate_required) {
            if ('checkbox' === $this.attr('type') && !$this.is(':checked')) {
                $parent.removeClass('woocommerce-validated').addClass('woocommerce-invalid woocommerce-invalid-required-field');
                validated = false;
            } else if (($this.val() || '') === '') {
                $parent.removeClass('woocommerce-validated').addClass('woocommerce-invalid woocommerce-invalid-required-field');
                validated = false;
            }
        }

        if (validate_email && $this.val()) {
            /* https://stackoverflow.com/questions/2855865/jquery-validate-e-mail-address-regex */
            pattern = new RegExp(/^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[0-9a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i); // eslint-disable-line max-len

            if (!pattern.test($this.val())) {
                $parent.removeClass('woocommerce-validated').addClass('woocommerce-invalid woocommerce-invalid-email woocommerce-invalid-phone'); // eslint-disable-line max-len
                validated = false;
            }
        }

        if (validate_phone) {
            pattern = new RegExp(/[\s\#0-9_\-\+\/\(\)\.]/g);

            if (0 < $this.val().replace(pattern, '').length) {
                $parent.removeClass('woocommerce-validated').addClass('woocommerce-invalid woocommerce-invalid-phone');
                validated = false;
            }
        }

        if (validated) {
            $parent.removeClass('woocommerce-invalid woocommerce-invalid-required-field woocommerce-invalid-email woocommerce-invalid-phone').addClass('woocommerce-validated'); // eslint-disable-line max-len
        }
    }
}

function isInOrAboveViewport(el) {
    const rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight;
}

/**
 * Remove attendee forms from products, use during AJAX refresh rather than
 * moving elements around.
 */
function removeAttendeeFormsFromProducts() {
    $('.product').each(function () {
       if ($(this).parent().hasClass('event-product')) {
           return; // skip if a bundle as they handle their own tickets
       }

        $(this).find('.fooevents-tickets-group').remove();
        $(this).find('.attendee-placeholder-form').remove();
    });
}

function attachAttendeeFormsToProducts() {
    $('#fooevents_order_notes_page_load .fooevents-tickets-group').each(function () {
        const $el = $(this);
        const productId = $el.data('product-id');
        if (productId) {
            const $product = $(`#product-${productId}`);

            if ($product.length === 0 || $product.parent().hasClass('event-product')) {
                return; // skip if a bundle as they handle their own tickets
            }
            const $details = $product.find(`.product-details`);

            if ($details.find('.title-in-cart').length === 0) {
                $details.append(`<h3 class="title-in-cart">${FestivalI18n.in_your_cart}</h3>`);
            }

            // form needed to inherit CSS error styles from WooCommerce
            $details.append($('<form class="attendee-placeholder-form">').append($el));
        }
    });
}

function attachAttendeeFormsToSummary() {
    $('.title-in-cart').remove();
    $('.product .fooevents-tickets-group').each(function () {
        const $product = $(this).closest('.product').parent();
        if ($product.hasClass('event-product')) {
            return; // skip if a bundle as they handle their own tickets
        }
        $('#fooevents_order_notes_page_load').append($(this));
    });
}


function initializeAttendeeDropdowns() {

    if (window.localStorage && window.localStorage.getItem(CACHE_KEY + '_attendees')) {
        attendees = JSON.parse(window.localStorage.getItem(CACHE_KEY + '_attendees'));
    }

    if (attendees.length === 0) {
        addPurchaser(attendees);
    }

    $('body')
        .on('change', '.attendee-dropdown', selectAttendeeFromDropdown)
        .on('click', '.save-attendee', saveAttendeeInfo)
        .on('input', '.fooevents-attendee .attendee-class :input', cacheAttendeeInputValue)
        .on('keydown', '.fooevents-attendee input', function (e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                saveAttendeeInfo.call(this);
            }
        })
        .on('click', '.attendee-edit', function () {
            const $edit = $(this);
            const $parent = $edit.closest('.fooevents-attendee');

            if ($edit.is(':hidden')) {
                $edit.show();
                $parent.find('.attendee-class').hide();
            } else {
                $edit.hide();
                $parent.find('.attendee-class').show();
            }
        }).on('blur', '.fooevents-attendee :input', function () {
        attendeeFieldValidator.call(this, new Event('validate'));
    });

    eventBus.on('refresh_order:start', function () {
        $('.fooevents-attendee:not(.fooevents-attendee-blank)').addClass('fooevents-attendee--updating');
    });

    initializeDropdowns(attendees);

    // reload the dropdown if the DOM has been updated from AJAX
    eventBus.on('attendees_reload', function () {
        initializeDropdowns(attendees, function () {
            loadAttendeeInputsFromCache();
            if ($('#fooevents_order_notes_page_load').length > 0) {
                if (!isInOrAboveViewport($('#fooevents_order_notes_page_load')[0])) {
                    attachAttendeeFormsToProducts();
                } else {
                    removeAttendeeFormsFromProducts();
                    attachAttendeeFormsToSummary();
                }
            }
        });
    });

    const observer = new IntersectionObserver(function (entries) {
        // Do nothing if we're below the element
        if (entries[0].boundingClientRect.top < 0) {
            return;
        }

        if (entries[0].isIntersecting) {
            attachAttendeeFormsToSummary();
        } else {
            attachAttendeeFormsToProducts();
        }
    }, {rootMargin: '100px 0px 100px 0px'});
    const element = document.querySelector('.woocommerce-additional-fields');
    if (element) {
        observer.observe(element);
    }
}

export default initializeAttendeeDropdowns;